export default {
  'pl': {
    'DRAFT': 'Oferta',
    'CUSTOMER_ORDER': 'Zamówienie klienta',
    'INQUIRY': 'Zapytanie ofertowe',
    'NEW': 'Nowa oferta',
    'SENT_TO_CUSTOMER': 'Wysłana do klienta',
    'TO_COLLECT': 'Do zebrania',
    'WAITING_PURCHASE_PRODUCTS': 'Oczekuje na produkty',
    'ORDER': 'Zamówienie',
    'IN_PRODUCTION': 'W produkcji',
    'TO_CHECK': 'Do sprawdzenia na magazynie',
    'PREPARATION_FOR_SHIPPING': 'Gotowe do wysyłki',
    'WAITING_FOR_SHIPPING': 'Czeka na wysyłkę',
    'SENT': 'Wysłane',
    'PENDING_PAYMENT': 'Oczekuje na płatność',
    'ENDED': 'Zakończone',
    'TO_DELETE': 'Do usunięcia',
    'DELETED': 'Usunięte',
    'OFFER_CLOSED': 'Nieaktualna oferta',
    'REQUEST_INVOICE': 'Żądanie wystawienia faktury',
    'REQUEST_ADVANCE_INVOICE': 'Żądanie wystawienia faktury zaliczkowej'
  },
  'en': {
    'DRAFT': 'Draft',
    'CUSTOMER_ORDER': 'Customer order',
    'INQUIRY': 'Inquiry',
    'NEW': 'New offer',
    'SENT_TO_CUSTOMER': 'Sent to customer',
    'TO_COLLECT': 'To collect',
    'WAITING_PURCHASE_PRODUCTS': 'Waiting purchase products',
    'ORDER': 'Order',
    'IN_PRODUCTION': 'In production',
    'TO_CHECK': 'To check in warehouse',
    'PREPARATION_FOR_SHIPPING': 'Preparation for shipping',
    'WAITING_FOR_SHIPPING': 'Waiting for shipping',
    'SENT': 'Sent',
    'PENDING_PAYMENT': 'Pending payment',
    'ENDED': 'Ended',
    'TO_DELETE': 'To delete',
    'DELETED': 'Deleted',
    'OFFER_CLOSED': 'Offer closed',
    'REQUEST_INVOICE': 'Request for an invoice',
    'REQUEST_ADVANCE_INVOICE': 'Request for an advance invoice'
  },
  'de': {
    'DRAFT': 'Angebot',
    'CUSTOMER_ORDER': 'Kundenbestellung',
    'INQUIRY': 'Anfrage',
    'NEW': 'Neues Angebot',
    'SENT_TO_CUSTOMER': 'An Kunden gesendet',
    'TO_COLLECT': 'Zu kommissionieren',
    'WAITING_PURCHASE_PRODUCTS': 'Wartet auf Produkte',
    'ORDER': 'Bestellung',
    'IN_PRODUCTION': 'In Produktion',
    'TO_CHECK': 'Im Lager prüfen',
    'PREPARATION_FOR_SHIPPING': 'Versandbereit',
    'WAITING_FOR_SHIPPING': 'Wartet auf Versand',
    'SENT': 'Versendet',
    'PENDING_PAYMENT': 'Wartet auf Zahlung',
    'ENDED': 'Abgeschlossen',
    'TO_DELETE': 'Zum Löschen',
    'DELETED': 'Gelöscht',
    'OFFER_CLOSED': 'Angebot nicht mehr aktuell',
    'REQUEST_INVOICE': 'Anforderung einer Rechnung',
    'REQUEST_ADVANCE_INVOICE': 'Anforderung einer Anzahlungsrechnung'
  },
  'fr': {
    'DRAFT': 'Offre',
    'CUSTOMER_ORDER': 'Commande client',
    'INQUIRY': 'Demande de devis',
    'NEW': 'Nouvelle offre',
    'SENT_TO_CUSTOMER': 'Envoyée au client',
    'TO_COLLECT': 'À préparer',
    'WAITING_PURCHASE_PRODUCTS': 'En attente des produits',
    'ORDER': 'Commande',
    'IN_PRODUCTION': 'En production',
    'TO_CHECK': 'À vérifier en stock',
    'PREPARATION_FOR_SHIPPING': 'Prêt pour l’expédition',
    'WAITING_FOR_SHIPPING': 'En attente d’expédition',
    'SENT': 'Envoyé',
    'PENDING_PAYMENT': 'En attente de paiement',
    'ENDED': 'Terminé',
    'TO_DELETE': 'À supprimer',
    'DELETED': 'Supprimé',
    'OFFER_CLOSED': 'Offre expirée',
    'REQUEST_INVOICE': 'Demande de facture',
    'REQUEST_ADVANCE_INVOICE': 'Demande de facture d’acompte'
  },
  'it': {
    'DRAFT': 'Offerta',
    'CUSTOMER_ORDER': 'Ordine cliente',
    'INQUIRY': 'Richiesta di offerta',
    'NEW': 'Nuova offerta',
    'SENT_TO_CUSTOMER': 'Inviata al cliente',
    'TO_COLLECT': 'Da preparare',
    'WAITING_PURCHASE_PRODUCTS': 'In attesa dei prodotti',
    'ORDER': 'Ordine',
    'IN_PRODUCTION': 'In produzione',
    'TO_CHECK': 'Da controllare in magazzino',
    'PREPARATION_FOR_SHIPPING': 'Pronto per la spedizione',
    'WAITING_FOR_SHIPPING': 'In attesa di spedizione',
    'SENT': 'Spedito',
    'PENDING_PAYMENT': 'In attesa di pagamento',
    'ENDED': 'Completato',
    'TO_DELETE': 'Da eliminare',
    'DELETED': 'Eliminato',
    'OFFER_CLOSED': 'Offerta non più valida',
    'REQUEST_INVOICE': 'Richiesta di fattura',
    'REQUEST_ADVANCE_INVOICE': 'Richiesta di fattura di acconto'
  }
};
